import { useTranslation } from 'react-i18next';
import { FlexflowCardStatus } from '../../types';
import {
  ActiveStatusWrapper,
  FrozenStatusWrapper,
  SuspendedStatusWrapper,
  RequestedStatusWrapper,
  NotRequestedStatusWrapper
} from './styles';
import { NotRequestedCardStatus } from '../../EmployeeDetails/types';

type ContractStatusProps = {
  flexflowCardStatus: FlexflowCardStatus;
  payflowStatus: ContractPayflowStatus;
  cardSuspendedBySwan?: boolean;
};

export enum ContractPayflowStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ON_LEAVE = 'on_leave',
  INCOMPLETE = 'incomplete'
}

export enum ContractFlexflowStatusToDisplay {
  REQUESTED = 'requested',
  SUSPENDED = 'suspended',
  ACTIVE = 'active',
  FROZEN = 'frozen',
  NOT_REQUESTED = 'notRequested'
}

const FlexflowStatusToDisplayTag = {
  [ContractFlexflowStatusToDisplay.REQUESTED]: RequestedStatusWrapper,
  [ContractFlexflowStatusToDisplay.SUSPENDED]: SuspendedStatusWrapper,
  [ContractFlexflowStatusToDisplay.ACTIVE]: ActiveStatusWrapper,
  [ContractFlexflowStatusToDisplay.FROZEN]: FrozenStatusWrapper,
  [ContractFlexflowStatusToDisplay.NOT_REQUESTED]: NotRequestedStatusWrapper
};
export const getStatusToDisplay = (
  payflowStatus: ContractPayflowStatus | undefined,
  flexflowStatus: FlexflowCardStatus | NotRequestedCardStatus,
  cardSuspendedBySwan?: boolean
): ContractFlexflowStatusToDisplay => {
  if (flexflowStatus === FlexflowCardStatus.UNACTIVATED) {
    if (
      payflowStatus === ContractPayflowStatus.INACTIVE ||
      payflowStatus === ContractPayflowStatus.INCOMPLETE ||
      payflowStatus === ContractPayflowStatus.ON_LEAVE
    ) {
      return ContractFlexflowStatusToDisplay.SUSPENDED;
    }

    return ContractFlexflowStatusToDisplay.REQUESTED;
  }

  if (flexflowStatus === FlexflowCardStatus.ACTIVE && payflowStatus !== ContractPayflowStatus.ACTIVE) {
    return ContractFlexflowStatusToDisplay.SUSPENDED;
  }

  if (flexflowStatus === NotRequestedCardStatus.NOT_REQUESTED) {
    return ContractFlexflowStatusToDisplay.NOT_REQUESTED;
  }

  if (flexflowStatus === FlexflowCardStatus.SUSPENDED) {
    if (payflowStatus === ContractPayflowStatus.ACTIVE) {
      return ContractFlexflowStatusToDisplay.FROZEN;
    }

    return ContractFlexflowStatusToDisplay.SUSPENDED;
  }

  return ContractFlexflowStatusToDisplay.ACTIVE;
};

const ContractFlexflowStatusAfterInvitation = ({
  payflowStatus,
  flexflowCardStatus,
  cardSuspendedBySwan
}: ContractStatusProps) => {
  const { t } = useTranslation(['flexflow']);
  const statusToDisplay = getStatusToDisplay(payflowStatus, flexflowCardStatus, cardSuspendedBySwan);
  const StatusWrapperTag = statusToDisplay && FlexflowStatusToDisplayTag[statusToDisplay];

  if (!statusToDisplay || !StatusWrapperTag) {
    return <></>;
  }

  return (
    <StatusWrapperTag>
      {t(
        `employee status.${
          statusToDisplay === ContractFlexflowStatusToDisplay.ACTIVE ? statusToDisplay + '_new' : statusToDisplay
        }`,
        { ns: 'flexflow' }
      )}
    </StatusWrapperTag>
  );
};

export default ContractFlexflowStatusAfterInvitation;
